function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.119 6.002c.58-.277 1.148.016 1.491.302l2.058 1.718.002.002a1.32 1.32 0 01.044 2.022l-2.137 1.96 2.137 1.959a1.32 1.32 0 01-.046 2.023l-2.057 1.718-.002.001c-.343.285-.905.57-1.48.3-.577-.27-.719-.886-.719-1.337v-2.678l-2.313 2.121a.75.75 0 01-1.014-1.106l3.274-3.002-3.274-3.002a.75.75 0 111.014-1.106l2.313 2.121V7.34c0-.443.134-1.063.709-1.338zm.791 7.427l1.66 1.522-1.66 1.386v-2.908zm0-2.848V7.675l1.66 1.385-1.66 1.523z"
})));